var map = {
	"./Close_Teasure.png": 69289,
	"./Golden_Ticket.png": 56318,
	"./Open_Teasure.png": 55981,
	"./Silver_Ticket.png": 84453,
	"./approve.png": 85403,
	"./avatars/avatar-agent-01.png": 39703,
	"./avatars/avatar-king-01.png": 21984,
	"./avatars/avatar-king-02.png": 72609,
	"./avatars/avatar-leader-01.png": 8993,
	"./avatars/avatar-partner-01.png": 32765,
	"./avatars/manager/01.png": 58659,
	"./avatars/manager/02.png": 38061,
	"./avatars/manager/03.png": 69578,
	"./avatars/manager/04.png": 6539,
	"./avatars/manager/07.png": 51690,
	"./avatars/manager/08.png": 50723,
	"./avatars/manager/09.png": 95971,
	"./avatars/manager/10.png": 24760,
	"./avatars/owner/01.png": 87806,
	"./avatars/owner/02.png": 36759,
	"./avatars/owner/04.png": 93543,
	"./avatars/owner/05.png": 91426,
	"./avatars/partner/01.png": 78331,
	"./avatars/partner/02.png": 43624,
	"./avatars/staff/01.png": 79821,
	"./avatars/staff/02.png": 79896,
	"./avatars/staff/03.png": 52149,
	"./avatars/staff/04.png": 24841,
	"./avatars/staff/05.png": 4025,
	"./avatars/staff/06.png": 26870,
	"./avatars/staff/07.png": 24333,
	"./avatars/staff/08.png": 87469,
	"./avatars/staff/09.png": 52127,
	"./avatars/staff/10.png": 39764,
	"./avatars/staff/11.png": 12396,
	"./avatars/staff/12.png": 44178,
	"./avatars/staff/13.png": 80258,
	"./avatars/staff/14.png": 13485,
	"./avatars/staff/15.png": 86219,
	"./avatars/staff/16.png": 8015,
	"./avatars/staff/17.png": 6417,
	"./avatars/staff/18.png": 29242,
	"./avatars/staff/19.png": 38288,
	"./avatars/staff/20.png": 30366,
	"./avatars/staff/21.png": 92971,
	"./avatars/staff/22.png": 50849,
	"./avatars/staff/23.png": 16651,
	"./avatars/staff/24.png": 20476,
	"./avatars/staff/25.png": 6938,
	"./avatars/staff/26.png": 57993,
	"./avatars/staff/27.png": 65755,
	"./avatars/staff/28.png": 79742,
	"./avatars/staff/29.png": 9113,
	"./avatars/staff/30.png": 29552,
	"./avatars/staff/31.png": 32530,
	"./avatars/staff/32.png": 73399,
	"./avatars/staff/33.png": 3244,
	"./avatars/staff/34.png": 69438,
	"./avatars/staff/35.png": 87735,
	"./avatars/staff/36.png": 49619,
	"./avatars/system/01.png": 37074,
	"./avatars/system/02.png": 43998,
	"./banking/smooth-corner.png": 16046,
	"./banking/square.png": 37901,
	"./banking/th/smooth-corner/baac.png": 99594,
	"./banking/th/smooth-corner/bay.png": 24673,
	"./banking/th/smooth-corner/bbl.png": 76802,
	"./banking/th/smooth-corner/bnp.png": 75906,
	"./banking/th/smooth-corner/boa.png": 73979,
	"./banking/th/smooth-corner/cacib.png": 62443,
	"./banking/th/smooth-corner/cimb.png": 90481,
	"./banking/th/smooth-corner/citi.png": 88862,
	"./banking/th/smooth-corner/db.png": 50123,
	"./banking/th/smooth-corner/ghb.png": 79131,
	"./banking/th/smooth-corner/gsb.png": 42297,
	"./banking/th/smooth-corner/hsbc.png": 58454,
	"./banking/th/smooth-corner/ibank.png": 78345,
	"./banking/th/smooth-corner/icbc.png": 74454,
	"./banking/th/smooth-corner/jpm.png": 19876,
	"./banking/th/smooth-corner/kbank.png": 50185,
	"./banking/th/smooth-corner/kkp.png": 95417,
	"./banking/th/smooth-corner/ktb.png": 72885,
	"./banking/th/smooth-corner/lhb.png": 24579,
	"./banking/th/smooth-corner/mb.png": 56562,
	"./banking/th/smooth-corner/mega.png": 28779,
	"./banking/th/smooth-corner/mufg.png": 45618,
	"./banking/th/smooth-corner/promptpay.png": 64206,
	"./banking/th/smooth-corner/rbs.png": 60224,
	"./banking/th/smooth-corner/sc.png": 38771,
	"./banking/th/smooth-corner/scb.png": 49982,
	"./banking/th/smooth-corner/smbc.png": 51775,
	"./banking/th/smooth-corner/tbank.png": 33737,
	"./banking/th/smooth-corner/tcrb.png": 11078,
	"./banking/th/smooth-corner/tisco.png": 79875,
	"./banking/th/smooth-corner/tmb.png": 61123,
	"./banking/th/smooth-corner/truewallet.png": 41508,
	"./banking/th/smooth-corner/ttb.png": 79747,
	"./banking/th/smooth-corner/uob.png": 26507,
	"./banking/th/square/baac.png": 5725,
	"./banking/th/square/bay.png": 22596,
	"./banking/th/square/bbl.png": 78286,
	"./banking/th/square/bnp.png": 67278,
	"./banking/th/square/boa.png": 43952,
	"./banking/th/square/cacib.png": 95942,
	"./banking/th/square/cimb.png": 65568,
	"./banking/th/square/citi.png": 18467,
	"./banking/th/square/db.png": 73990,
	"./banking/th/square/ghb.png": 10549,
	"./banking/th/square/gsb.png": 50910,
	"./banking/th/square/hsbc.png": 44113,
	"./banking/th/square/ibank.png": 6140,
	"./banking/th/square/icbc.png": 36619,
	"./banking/th/square/jpm.png": 20789,
	"./banking/th/square/kbank.png": 64759,
	"./banking/th/square/kk.png": 60037,
	"./banking/th/square/ktb.png": 3308,
	"./banking/th/square/lhb.png": 91573,
	"./banking/th/square/mb.png": 60928,
	"./banking/th/square/mega.png": 40262,
	"./banking/th/square/mufg.png": 33172,
	"./banking/th/square/promptpay.png": 71552,
	"./banking/th/square/rbs.png": 93087,
	"./banking/th/square/sc.png": 64365,
	"./banking/th/square/scb.png": 35088,
	"./banking/th/square/smbc.png": 98860,
	"./banking/th/square/tbank.png": 36492,
	"./banking/th/square/tcrb.png": 63662,
	"./banking/th/square/tisco.png": 67365,
	"./banking/th/square/tmb.png": 14580,
	"./banking/th/square/ttb.png": 32015,
	"./banking/th/square/uob.png": 94631,
	"./banking/th/white/baac.png": 15522,
	"./banking/th/white/bay.png": 79370,
	"./banking/th/white/bbl.png": 35012,
	"./banking/th/white/bnp.png": 21168,
	"./banking/th/white/boa.png": 62456,
	"./banking/th/white/cacib.png": 69795,
	"./banking/th/white/cimb.png": 91137,
	"./banking/th/white/citi.png": 6503,
	"./banking/th/white/db.png": 69483,
	"./banking/th/white/ghb.png": 40912,
	"./banking/th/white/gsb.png": 92542,
	"./banking/th/white/hsbc.png": 14843,
	"./banking/th/white/ibank.png": 31583,
	"./banking/th/white/icbc.png": 2795,
	"./banking/th/white/jpm.png": 86957,
	"./banking/th/white/kbank.png": 74326,
	"./banking/th/white/kk.png": 58025,
	"./banking/th/white/ktb.png": 33600,
	"./banking/th/white/lhb.png": 70531,
	"./banking/th/white/mb.png": 69758,
	"./banking/th/white/mega.png": 28737,
	"./banking/th/white/mufg.png": 33349,
	"./banking/th/white/promptpay.png": 72096,
	"./banking/th/white/rbs.png": 75477,
	"./banking/th/white/sc.png": 40862,
	"./banking/th/white/scb.png": 65049,
	"./banking/th/white/smbc.png": 17629,
	"./banking/th/white/tbank.png": 9589,
	"./banking/th/white/tcrb.png": 83916,
	"./banking/th/white/tisco.png": 16258,
	"./banking/th/white/tmb.png": 70816,
	"./banking/th/white/ttb.png": 56374,
	"./banking/th/white/uob.png": 36845,
	"./banking/white.png": 51989,
	"./banner-baccarat-01.png": 73700,
	"./banner-keno-01.png": 99035,
	"./banner-lotto-01.png": 69652,
	"./banner-poker-01.png": 13830,
	"./banner-slot-01.png": 67407,
	"./banner-sport-01.png": 81530,
	"./bg-002.png": 57745,
	"./cancel.png": 59685,
	"./demo/nav-game-demo1.png": 14919,
	"./demo/nav-game-demo2.png": 69829,
	"./demo/nav-game-demo3.png": 20724,
	"./demo/nav-game-demo4.png": 63781,
	"./demo/nav-game-demo5.png": 31895,
	"./demo/nav-game-demo6.png": 89186,
	"./gamescard/content_card_1.png": 29370,
	"./gamescard/content_casino_1.png": 42527,
	"./gamescard/content_fishing_1.png": 71395,
	"./gamescard/content_keno_1.png": 54900,
	"./gamescard/content_slot_1.png": 78425,
	"./gamescard/content_sport_1.png": 63517,
	"./gameshall/ag.png": 57905,
	"./gameshall/ameba.png": 80490,
	"./gameshall/dg.png": 69602,
	"./gameshall/ds.png": 41127,
	"./gameshall/gmt.png": 47801,
	"./gameshall/live22.png": 68812,
	"./gameshall/pg.png": 93806,
	"./gameshall/pt.png": 83722,
	"./gameshall/sa.png": 16841,
	"./gameshall/sexy.png": 32630,
	"./gameshall/spg.png": 94902,
	"./gameshall/xo.png": 58627,
	"./home-promotion-01.png": 5859,
	"./home-promotion-02.png": 40590,
	"./pending.png": 97014,
	"./social/facebook.png": 36843,
	"./social/instagram.png": 35656,
	"./social/line.png": 22412,
	"./social/telegram.png": 27892,
	"./social/twitter.png": 17243,
	"./social/youtube.png": 56056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;